var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useDocumentLibraryTranslations } from '../../../hooks';
import { humanReadableFileSize } from '../../../utils';
import { getTotalSize } from '../utils/getTotalSize';
import { handleSelectedFilesValidation } from '../utils/handleSelectedFilesValidation';
export const SelectFilesDialogFooter = ({ selectButtonLabel, onFilesSelect, selectedFiles, maxFilesSize, maxFilesCount, preselectedFilesSize, preselectedFilesCount, }) => {
    const [isSelectButtonEnabled, setIsSelectButtonEnabled] = React.useState(true);
    const { t } = useDocumentLibraryTranslations();
    const selectedFilesSize = getTotalSize(selectedFiles) + (preselectedFilesSize !== null && preselectedFilesSize !== void 0 ? preselectedFilesSize : 0);
    const selectedFilesCount = selectedFiles.length + (preselectedFilesCount !== null && preselectedFilesCount !== void 0 ? preselectedFilesCount : 0);
    const { isMaxFilesCountExceeded, isMaxFilesSizeExceeded } = handleSelectedFilesValidation({
        selectedFilesSize,
        selectedFilesCount,
        maxFilesCount,
        maxFilesSize,
    });
    return (React.createElement(Box, { sx: {
            alignItems: 'center',
            display: 'flex',
            gap: 2,
            justifyContent: 'end',
            p: 2,
        } },
        React.createElement(Typography, { sx: Object.assign({}, ((isMaxFilesCountExceeded || isMaxFilesSizeExceeded) && { color: themeColors.accent.red.bold })) },
            selectedFilesCount,
            " ",
            t('selectFilesDialog.filesSelected'),
            ' ',
            React.createElement(Typography, { fontWeight: '500', component: 'span' },
                "(",
                humanReadableFileSize(selectedFilesSize),
                "/",
                humanReadableFileSize(maxFilesSize),
                ")")),
        React.createElement(Button, { variant: 'contained', color: 'primary', disabled: !isSelectButtonEnabled, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    setIsSelectButtonEnabled(false);
                    yield onFilesSelect();
                }
                catch (error) {
                    showErrorDialog({ title: t('selectFilesDialog.error') });
                }
                finally {
                    setIsSelectButtonEnabled(true);
                }
            }) }, selectButtonLabel !== null && selectButtonLabel !== void 0 ? selectButtonLabel : t('selectFilesDialog.select'))));
};
